import { render, staticRenderFns } from "./ArrivalDialog.vue?vue&type=template&id=c1b46306"
import script from "./ArrivalDialog.vue?vue&type=script&lang=js"
export * from "./ArrivalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports